import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["imageInput", "imagePreview", "analyzeButton", "dropZone", "loadingIndicator", "previewImage"]

  connect() {
    this.boundDragOver = this.dragOver.bind(this)
    this.boundDragLeave = this.dragLeave.bind(this)
    this.boundDrop = this.drop.bind(this)

    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.addEventListener("dragover", this.boundDragOver)
      this.dropZoneTarget.addEventListener("dragleave", this.boundDragLeave)
      this.dropZoneTarget.addEventListener("drop", this.boundDrop)
    }
  }

  disconnect() {
    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.removeEventListener("dragover", this.boundDragOver)
      this.dropZoneTarget.removeEventListener("dragleave", this.boundDragLeave)
      this.dropZoneTarget.removeEventListener("drop", this.boundDrop)
    }
  }

  fileSelected() {
    const file = this.imageInputTarget.files[0]
    if (!file) return

    this.showPreview(file)
    this.analyzeButtonTarget.disabled = false
    this.analyzeButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    this.analyzeButtonTarget.classList.add("hover:bg-emerald-600")
  }

  dragOver(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.add("border-emerald-500", "bg-emerald-50")
    this.dropZoneTarget.classList.remove("border-slate-300")
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove("border-emerald-500", "bg-emerald-50")
    this.dropZoneTarget.classList.add("border-slate-300")
  }

  drop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove("border-emerald-500", "bg-emerald-50")
    this.dropZoneTarget.classList.add("border-slate-300")

    const files = event.dataTransfer.files
    if (files.length === 0) return

    const file = files[0]
    if (!file.type.startsWith("image/")) return

    // Set the file input
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.imageInputTarget.files = dataTransfer.files

    this.showPreview(file)
    this.analyzeButtonTarget.disabled = false
    this.analyzeButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    this.analyzeButtonTarget.classList.add("hover:bg-emerald-600")
  }

  showPreview(file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewImageTarget.src = e.target.result
      this.imagePreviewTarget.classList.remove("hidden")
    }
    reader.readAsDataURL(file)
  }

  submitAnalyze() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.remove("hidden")
    }
    this.analyzeButtonTarget.disabled = true
    this.analyzeButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
  }

  // Called when turbo:submit-end fires to reset loading state
  resetLoading() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add("hidden")
    }
    if (this.imageInputTarget.files.length > 0) {
      this.analyzeButtonTarget.disabled = false
      this.analyzeButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    }
  }

  browseFiles() {
    this.imageInputTarget.click()
  }
}
